import { Box, SxProps } from '@mui/material';
import React from 'react';
import headerCloud from '../assets/header-cloud.svg';
import headerSite from '../assets/header-site.svg';
import { ExerciseType, SimulatorType } from '../types';
import { getBgColor, getKSim, getSmallHeaderBg } from '../utils/ksim';

export interface KSimHeaderProps {
  adHoc?: boolean;
  exerciseType: ExerciseType;
  /**
   * If true, show only mobile variant event on desktop
   */
  mobileOnly?: boolean;
  simulatorType?: SimulatorType;
  sx?: SxProps;
}

const KSimHeader = ({ adHoc, exerciseType, mobileOnly, simulatorType, sx = {} }: KSimHeaderProps) => {
  const ksim = getKSim(exerciseType, simulatorType);

  return (
    <Box
      sx={{
        borderRadius: 2,
        backgroundColor: getBgColor(simulatorType, adHoc),
        backgroundImage: mobileOnly
          ? `url(${getSmallHeaderBg(simulatorType, adHoc)})`
          : {
              xs: `url(${getSmallHeaderBg(simulatorType)})`,
              sm: `url(${simulatorType === SimulatorType.Cloud ? headerCloud : headerSite})`, // TODO: neutral desktop img
            },
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'grid',
        height: { xs: 129, sm: 184 },
        placeContent: 'center',
        ...sx,
      }}
    >
      <Box component="img" src={ksim} height={mobileOnly ? 85 : { xs: 75, sm: 140 }} alt="K-Sim" />
    </Box>
  );
};

export default KSimHeader;
